import { render, staticRenderFns } from "./RewardedTransactions.vue?vue&type=template&id=5cd6fc66"
import script from "./RewardedTransactions.vue?vue&type=script&lang=js"
export * from "./RewardedTransactions.vue?vue&type=script&lang=js"
import style0 from "./RewardedTransactions.vue?vue&type=style&index=0&id=5cd6fc66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports